module.exports = __webpack_public_path__ + "img/resized-APP-0013-2.0f42b27e.png";